import {createApp} from 'vue'
import Store from 'store'
import BasketComponent from './BasketComponent'

const el = '.nlx-component--basket-component'
const DOM = document.querySelector(el)
const component = createApp(BasketComponent).use(Store)

if(DOM){
    const customerServiceReasons = DOM.getAttribute('data-customer-service-reason')
    if (customerServiceReasons) {
        Store.commit('ecom/set_customer_service_reason_codes', JSON.parse(customerServiceReasons))
    }
    
    component.mount(el)
}
